import { useDispatch, useSelector } from 'react-redux';
import type { AppDispatch, RootState } from '../store';

/** Typed dispatch/selector hooks — plain useDispatch loses the thunk types. */
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
